export default __webpack_public_path__ + "static/media/igor_demchuk.6bcfe7c0.jpg";